// extracted by mini-css-extract-plugin
module.exports = {"container":"afterHoursNote_container__3JS9R","note":"afterHoursNote_note__3n1W7"};